import React, { useState, useEffect } from "react";
import {
  getAllProgressPhases,
  updateProgressPhase,
  deleteProgressPhase,
} from "./../../../../services/progressPhasesServices";
import {
  getAllProgressTrackingPhases,
  togglePhaseStatus,
} from "./../../../../services/progressTrackingServices";

const ProgressPhasesList = () => {
  const [phases, setPhases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingPhase, setEditingPhase] = useState(null);
  const [newData, setNewData] = useState({ phase: "", ordre: 0 });
  const [trackingData, setTrackingData] = useState([]);

  useEffect(() => {
    const fetchPhases = async () => {
      setLoading(true);
      try {
        const data = await getAllProgressPhases();
        setPhases(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erreur de récupération des phases :", error);
        setPhases([]);
      } finally {
        setLoading(false);
      }
    };
    fetchPhases();
  }, []);

  useEffect(() => {
    const fetchTracking = async () => {
      try {
        const data = await getAllProgressTrackingPhases();
        setTrackingData(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erreur récupération suivi par asso :", error);
        setTrackingData([]);
      }
    };
    fetchTracking();
  }, []);

  const handleEditClick = (phase) => {
    setEditingPhase(phase.id);
    setNewData({ phase: phase.phase, ordre: phase.ordre });
  };

  const handleUpdatePhase = async () => {
    try {
      await updateProgressPhase(editingPhase, newData);
      setPhases((prev) =>
        prev.map((item) =>
          item.id === editingPhase ? { ...item, ...newData } : item
        )
      );
      setEditingPhase(null);
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
    }
  };

  const handleDeletePhase = async (id) => {
    if (!window.confirm("Confirmer la suppression de cette phase ?")) return;
    try {
      await deleteProgressPhase(id);
      setPhases((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
    }
  };

  return (
    <div className="max-w-[800px] mx-auto mt-10">
      {trackingData.length > 0 && (
        <div className="overflow-auto mb-10">
          <h2 className="text-xl font-bold mb-4">Suivi des Associations</h2>
          <table className="min-w-full border text-sm text-center">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-2 py-1 border">Nom Association</th>
                {[...Array(16)].map((_, i) => (
                  <th key={i + 1} className="px-2 py-1 border">
                    #{i + 1}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Object.entries(
                trackingData.reduce((acc, curr) => {
                  const assoId = curr.association_id;
                  const nomAsso =
                    curr.Association && curr.Association.nom_asso
                      ? curr.Association.nom_asso
                      : `Association ID ${assoId}`;

                  if (!acc[assoId]) {
                    acc[assoId] = {
                      nom: nomAsso,
                      phases: {},
                    };
                  }

                  // S'assurer que la phase est bien définie
                  const phaseId = curr.ProgressPhase?.id;
                  if (phaseId) {
                    acc[assoId].phases[phaseId] = curr.is_done;
                  }

                  return acc;
                }, {})
              ).map(([assoId, { nom, phases }]) => (
                <tr key={assoId} className="hover:bg-gray-50">
                  <td className="border px-2 py-1 font-medium text-left">
                    {nom}
                  </td>
                  {[...Array(16)].map((_, i) => {
                    const phaseDone = phases[i + 1];
                    return (
                      <td
                        key={i + 1}
                        className="border px-2 py-1 cursor-pointer hover:bg-gray-100"
                        title={
                          trackingData.find(
                            (t) =>
                              t.association_id.toString() === assoId &&
                              t.ProgressPhase?.id === i + 1
                          )?.ProgressPhase?.phase || "Phase inconnue"
                        }
                        onClick={async () => {
                          const line = trackingData.find(
                            (t) =>
                              t.association_id.toString() === assoId &&
                              t.ProgressPhase?.id === i + 1
                          );
                          if (line) {
                            const res = await togglePhaseStatus(line.id);
                            if (res) {
                              setTrackingData((prev) =>
                                prev.map((item) =>
                                  item.id === line.id
                                    ? {
                                        ...item,
                                        is_done: res.newStatus,
                                        completedAt: res.newStatus
                                          ? new Date()
                                          : null,
                                      }
                                    : item
                                )
                              );
                            }
                          }
                        }}
                      >
                        {phaseDone ? "✅" : "❌"}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <h2 className="text-2xl font-bold mb-6">
        Liste des Phases de Progression
      </h2>

      {loading ? (
        <p>Chargement en cours...</p>
      ) : (
        <div className="space-y-4">
          {phases.map((phase) => (
            <div
              key={phase.id}
              className="border rounded p-4 shadow bg-white space-y-2"
            >
              {editingPhase === phase.id ? (
                <>
                  <input
                    type="text"
                    value={newData.phase}
                    onChange={(e) =>
                      setNewData({ ...newData, phase: e.target.value })
                    }
                    className="w-full border p-2 mb-2 rounded"
                  />
                  <input
                    type="number"
                    value={newData.ordre}
                    onChange={(e) =>
                      setNewData({
                        ...newData,
                        ordre: parseInt(e.target.value),
                      })
                    }
                    className="w-full border p-2 mb-2 rounded"
                  />
                  <div className="flex justify-end gap-2">
                    <button
                      className="bg-red-500 text-white px-3 py-1 rounded"
                      onClick={() => setEditingPhase(null)}
                    >
                      Annuler
                    </button>
                    <button
                      className="bg-blue-600 text-white px-3 py-1 rounded"
                      onClick={handleUpdatePhase}
                    >
                      Sauvegarder
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <p className="text-lg font-semibold">{phase.phase}</p>
                  <p className="text-sm text-gray-600">Ordre : {phase.ordre}</p>
                  <div className="flex justify-end gap-2">
                    <button
                      className="bg-yellow-500 text-white px-3 py-1 rounded"
                      onClick={() => handleEditClick(phase)}
                    >
                      Modifier
                    </button>
                    <button
                      className="bg-red-600 text-white px-3 py-1 rounded"
                      onClick={() => handleDeletePhase(phase.id)}
                    >
                      Supprimer
                    </button>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProgressPhasesList;
